import { FileData } from 'src/data-capture/hooks/file-uploads/types';

export type Fund = {
  id: string;
  name: string;
  type: string;
  pricePerUnit: number;
  code: string;
  amcPercentage: number;
  fundFiles: FundDocument[];
};

export type FundReportType = 'FUND_FACT_SHEET' | 'RISK_PROFILE' | 'OTHER';

export type FundDocument = {
  id: string;
  file: FileData;
  isLatest: boolean;
  reportType: FundReportType;
  reportDate: Date;
};

export type CompanyAppendix = {
  id: string;
  createdAt: string;
  file: {
    id: number;
    fileName: string;
    fileSize: number;
    fileType: string;
  };
  uploadedByName: string | null;
  isArchived: boolean;
};

export type CompanyFile = {
  id: number;
  parentId: number | null;
  isFolder: boolean;
  fileName: string;
  fileSize: number | null;
  fileType: string | null;
  isResolved: boolean;
  createdAt: string;
};

export const CompanyTabs = {
  funds: 'funds',
  providers: 'providers',
  connectedAssets: 'connected-assets',
  templates: 'templates',
  appendices: 'appendices',
  documents: 'documents',
  memories: 'memories',
} as const;
